import { EMPTY_LIST } from '../../../constants/common'
import { Divider } from '../../Divider'

export function getMassActionsWithDivider(actions = EMPTY_LIST) {
  return actions.map((action, index) => {
    if (action === null) {
      return {
        Divider,
        value: `divider-${index}`, // we need a value to compute it as a key in SelectDropdownList
      }
    }

    return action
  })
}
